import React, { useState, useRef, useEffect } from "react";
import { Button, Dialog, DialogContent, DialogTitle, Stack } from "@mui/material";

const AddEditClient = (props) => {
  const initialFieldValues = {
    stage: "",
    performers: [""],
    email: "",
    splitCheck: false,
    duo: false,
    bio: "",
  };

  var [values, setValues] = useState(initialFieldValues);
  const initialFieldValuesRef = useRef(initialFieldValues);

  useEffect(() => {
    const clientData =
      props.currentId === ""
        ? initialFieldValuesRef.current
        : props.ClientObj[props.currentId] || {};
    setValues({
      ...initialFieldValuesRef.current,
      ...clientData,
      performers: clientData.performers || initialFieldValuesRef.current.performers,
    });
  }, [props.currentId, props.ClientObj]);

  const [open, setOpen] = useState(false);

  // Open dialog when parent sets openDialog=true (e.g. clicking Edit in the table)
  useEffect(() => {
    if (props.dialogOpen) {
      setOpen(true);
    }
  }, [props.dialogOpen]);

  const handleInputChange = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handlePerformerChange = (index, e) => {
    const newPerformers = values.performers.slice();
    newPerformers[index] = e.target.value;
    setValues({
      ...values,
      performers: newPerformers,
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    let updatedValues = { ...values };
    if (values.duo === true) {
      updatedValues = {
        ...updatedValues,
        stage: values.stage + "\u00A0",
      };
    }
    props.addOrEdit(updatedValues);
    handleClose();
  };

  const addPerformer = (e) => {
    e.preventDefault();
    setValues({
      ...values,
      performers: [...values.performers, ""],
    });
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value === "true",
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    if (props.currentId !== '') {
      props.setCurrentId('');
    }
    if (props.onDialogClose) {
      props.onDialogClose();
    }
  };

  return (
    <>
      <Button variant="contained" onClick={handleClickOpen}>
        {props.currentId === "" ? "Add Artist" : "Edit Artist"}
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {props.currentId === "" ? "Add Artist" : "Edit Artist"}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <form autoComplete="off" onSubmit={handleFormSubmit}>
              <div className="card-body">
                <div className="center-form">
                  <div className="row">
                    {/* Performers Input Field */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="col-form-label">
                          Performers
                          <span className="mandatoryFieldColor">*&nbsp;</span>
                        </label>
                        {values.performers.map((performer, index) => (
                          <input
                            key={index}
                            type="text"
                            className="form-control"
                            placeholder="Input performer name"
                            value={performer}
                            onChange={(e) => handlePerformerChange(index, e)}
                          />
                        ))}
                        <button type="button" onClick={addPerformer}>
                          &nbsp;Add Performer&nbsp;
                        </button>
                      </div>
                    </div>

                    {/* Stage Name Input Field */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="col-form-label">
                          Stage Name
                          <span className="mandatoryFieldColor">*</span>
                        </label>
                        <input
                          value={values.stage}
                          onChange={handleInputChange}
                          type="text"
                          className="form-control"
                          name="stage"
                        />
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="col-form-label">
                          Email<span className="mandatoryFieldColor">*</span>
                        </label>
                        <input
                          value={values.email}
                          onChange={handleInputChange}
                          type="text"
                          className="form-control"
                          name="email"
                        />
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="col-form-label">
                          Split Check?
                          <span className="mandatoryFieldColor">*</span>
                        </label>
                        <div style={{ display: "flex", gap: "16px", alignItems: "center", marginTop: "4px" }}>
                          <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontWeight: "normal" }}>
                            <input
                              name="splitCheck"
                              value="true"
                              checked={values.splitCheck === true}
                              onChange={handleFieldChange}
                              type="radio"
                            />
                            Yes
                          </label>
                          <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontWeight: "normal" }}>
                            <input
                              name="splitCheck"
                              value="false"
                              checked={values.splitCheck === false}
                              onChange={handleFieldChange}
                              type="radio"
                            />
                            No
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="col-form-label">
                          Duo?
                          <span className="mandatoryFieldColor">*</span>
                        </label>
                        <div style={{ display: "flex", gap: "16px", alignItems: "center", marginTop: "4px" }}>
                          <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontWeight: "normal" }}>
                            <input
                              name="duo"
                              value="true"
                              checked={values.duo === true}
                              onChange={handleFieldChange}
                              type="radio"
                            />
                            Yes
                          </label>
                          <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontWeight: "normal" }}>
                            <input
                              name="duo"
                              value="false"
                              checked={values.duo === false}
                              onChange={handleFieldChange}
                              type="radio"
                            />
                            No
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="col-form-label">Bio</label>
                        <textarea
                          value={values.bio}
                          onChange={handleInputChange}
                          className="form-control"
                          name="bio"
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="btn-group mb-3 mt-2 cmn-btn-grp">
                <input
                  type="submit"
                  value={props.currentId === "" ? "Save" : "Update"}
                  className="btn btn-success btn-block"
                />
              </div>
            </form>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddEditClient;
